import { render, staticRenderFns } from "./NationalDayChess.vue?vue&type=template&id=3cf54170&scoped=true&"
import script from "./NationalDayChess.vue?vue&type=script&lang=js&"
export * from "./NationalDayChess.vue?vue&type=script&lang=js&"
import style0 from "./NationalDayChess.vue?vue&type=style&index=0&id=3cf54170&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf54170",
  null
  
)

export default component.exports